jQuery(function($) {
  // ページトップに戻るボタンをクリックした時のスムーズスクロール
  $('#page-top a').click(function() {
    $('html,body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 300);
    return false;
  })

  $(window).on('hashchange', () => {
    $('html').addClass('smoothScroll')
  })
});
